module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-4bar-da3c7116.svg";